import React from 'react';
import { EventPost } from '@feature/event-detail/types';
import { EventDetailBefore } from '@feature/event-detail/components/EventDetailBefore';
import { EventDetailDuring } from '@feature/event-detail/components/EventDetailDuring';
import { EventDetailAfter } from '@feature/event-detail/components/EventDetailAfter';
import { useEventDetail } from '@feature/event-detail/hooks/useEventDetail';
import { LoadingSpinner } from '@feature/event-detail/components/LoadingSpinner';

interface Props {
  event: EventPost;
}

export function EventDetailScreen({ event }: Props): React.ReactElement {
  const { mode, metadata, isLoading } = useEventDetail({
    eventId: event.id.toString(),
    event,
  });

  // Set CSS custom property for mobile viewport height
  React.useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);

  if (isLoading || !metadata) {
    return <LoadingSpinner />;
  }

  return (
    <div style={styles.container}>
      {mode === 'before' && <EventDetailBefore event={event} metadata={metadata} />}
      {mode === 'during' && <EventDetailDuring event={event} metadata={metadata} />}
      {mode === 'after' && <EventDetailAfter event={event} metadata={metadata} />}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    backgroundColor: '#fff',
    height: 'calc(var(--vh, 1vh) * 100)',
    width: '100%',
    maxWidth: '1000px',
    margin: '0 auto',
  },
};
